import { render, staticRenderFns } from "./CriticalTasksPanel.vue?vue&type=template&id=ad18643a&scoped=true&"
import script from "./CriticalTasksPanel.vue?vue&type=script&lang=js&"
export * from "./CriticalTasksPanel.vue?vue&type=script&lang=js&"
import style0 from "./CriticalTasksPanel.vue?vue&type=style&index=0&id=ad18643a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad18643a",
  null
  
)

export default component.exports